export default "__VITE_ASSET__b7a71ea9__"